export {watchModals} from '../../../src/aria-modal-polyfill/ariaModalPolyfill';
